import React from "react";
import { FieldErrors } from "react-hook-form";
import FieldError from "../FieldError";

interface CheckboxProps {
  name: string;
  label: string | JSX.Element;
  register: any;
  required?: string | boolean;
  errors?: FieldErrors;
  style?: object;
  lableStyle?: object;
  labelClass?: string;
}

const Checkbox = ({
  name,
  label,
  register,
  required,
  errors,
  style,
  lableStyle,
  labelClass = "",
}: CheckboxProps) => {
  return (
    <div className="checkbox-wrapper mb-5" style={{ ...style }}>
      <input
        type="checkbox"
        id={name}
        className="terms-check"
        {...register(name, { required })}
      />
      <label
        className={`terms-label ${labelClass}`}
        htmlFor={name}
        style={{ ...lableStyle }}
      >
        {label}
        {required && <span className="req-text">*</span>}
      </label>
      <FieldError error={errors?.[name]} info={null} />
    </div>
  );
};

export default Checkbox;
